import AppRecord from './AppRecord.js'
import APP from '../../../main.js'
const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
class Onboarding extends AppRecord {
  get includedStatusCodes(){
    let currentStatusValue = this.constructor.employeeStore.onboarding_status.find(status => status.key == this.onboarding_status)
    let statuses = this.constructor.employeeStore.onboarding_status.filter(status => status.id <= currentStatusValue.id)
    statuses = statuses.map(e => e.key)
    return statuses
  }

  field(reference, tableName, fieldName){
    let fieldy = null
    this.onboarding_steps.every(step => {
      fieldy = step.onboarding_step_data.find(field => {
        return field.reference === reference && field.table === tableName && field.field === fieldName
      })
      if (fieldy){
        return false
      }
      return true
    })
    return fieldy
  }

  valueForField(reference, tableName, fieldName){
    let ret = this.field(reference, tableName, fieldName)
    if (ret){
      return ret.value
    }
    return null
  }

  fields(tableName, fieldName){
    let fieldies = []
    this.onboarding_steps.forEach(step => {
      let mergy = step.onboarding_step_data.filter(field => {
        return field.table === tableName && field.field === fieldName
      })
      mergy.forEach(data => {
        fieldies.push(data)
      })
    })
    return fieldies
  }

  get canDelete_Status(){
    if (this.onboarding_status == 'admin' || this.onboarding_status == 'closed'){
      return false
    }
    return true
  }

  get canDelete_OnboardingRecords(){
    if (this.onboarding_records && this.onboarding_records.length > 0){
      return false
    }

    return true
  }

  get lastTouched(){
    let newDate = new Date(this.last_updated_at)
    if (newDate.getFullYear() < 1971){
      return ''
    }
    return newDate.toLocaleDateString(options).replace(/\//g, '-')
  }
}

export default Onboarding